import { useQuery } from '@tanstack/react-query'
import api from '../../api'
import type { Cluster } from '../../types/cluster'

const useSingleCluster = (clusterID: string) => {
	return useQuery({
		queryKey: ['cluster', clusterID],
		queryFn: () => api.clusters.getSingleCluster(clusterID),
		enabled: !!clusterID,
		retry: false,
		select(data) {
			const body = data?.body
			if (Array.isArray(body) && body.length > 0) return body[0] as Cluster
			if (body && typeof body === 'object' && !Array.isArray(body))
				return body as Cluster
			return null
		}
	})
}

export default useSingleCluster
